<template>
  <layout-tenant>
    <template slot="header">
      <page-title :title="courseTitle" :sub-title="currentCourse ? currentCourse.tipo_it : ''" />
    </template>
    <template>
      <teaching-instructions v-if="$route.name === 'course' && currentCourse && $userHasRoles(['erogazione_didattica'])"/>
      <transition name="fade-transition">
        <router-view />
      </transition>
    </template>
  </layout-tenant>
</template>

<script>
import { $EventBus } from '@/eventBus'
import { $cloudinaryUrl } from '@/mixins/cloudinary'
import pageTitle from '@/components/common/PageTitle'
import teachingInstructions from '@/components/courses/TeachingInstructions'
import layoutTenant from '@/components/layouts/LayoutTenant'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      currentCourse: 'courses/currentCourse'
    }),
    menu () {
      return {
        header: {
          image: this.currentCourse ? this.currentCourse.immagine : undefined
        },
        items: [
          {
            title: 'Didattica Covid-19',
            icon: 'fas fa-chalkboard',
            route: { name: 'course' }
          }
        ]
      }
    },
    courseTitle () {
      return this.currentCourse ? this.currentCourse.codice + ' - ' + (this.currentCourse.nome_it ? this.currentCourse.nome_it : this.currentCourse.nome_en) : ''
    }
  },
  components: {
    pageTitle,
    layoutTenant,
    teachingInstructions
  },
  mixins: [$cloudinaryUrl],
  watch: {
    $route (to, from) {
      // react to route changes...
      if (to !== from) {
        this.$store.dispatch('secondaryMenu/destroy')
        console.log(this.$route.params.id)
        this.loadRouteData()
      }
    },
    menu () {
      this.$store.dispatch('secondaryMenu/set', this.menu)
    }
  },
  methods: {
    loadRouteData () {
      this.$store.dispatch('courses/find', this.$route.params.id)
      $EventBus.$emit('menu.primary:close')
      this.$store.dispatch('secondaryMenu/set', this.menu) // crea comunque le voci del menu, a prescindere se visibile o meno (mobile)
      if (this.$vuetify.breakpoint.lgAndUp) { // schermo grande -> mostralo subito
        this.$store.dispatch('secondaryMenu/open')
      }
    }
  },
  mounted () {
    this.loadRouteData()
  },
  beforeDestroy () {
    this.$store.dispatch('secondaryMenu/destroy')
  }
}
</script>
